import {
  Component,
  ContentChildren,
  QueryList,
  Output,
  EventEmitter,
} from '@angular/core';
import {TabComponent} from '../tab/tab.component';

@Component({
  selector: 'app-tab-list',
  templateUrl: './tab-list.component.html',
  styleUrls: ['./tab-list.component.scss'],
})
export class TabListComponent {
  @Output() clickedTab = new EventEmitter<string>();
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
}
